// Zachte geluidsfeedback via WebAudio — geen audiobestanden nodig, laag volume,
// altijd uit te zetten (voorkeur bewaard in localStorage).

const KEY = 'dn_sound_muted';

export const isMuted = (): boolean => {
  try { return localStorage.getItem(KEY) === '1'; } catch { return false; }
};

export const setMuted = (m: boolean): void => {
  try { localStorage.setItem(KEY, m ? '1' : '0'); } catch { /* negeer */ }
};

let ctx: AudioContext | null = null;
const ac = (): AudioContext | null => {
  const AC: typeof AudioContext | undefined = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AC) return null;
  if (!ctx) ctx = new AC();
  if (ctx.state === 'suspended') ctx.resume();
  return ctx;
};

function tone(freq: number, t0: number, dur: number, type: OscillatorType = 'sine', gain = 0.055) {
  const c = ac();
  if (!c) return;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.value = freq;
  g.gain.setValueAtTime(0.0001, c.currentTime + t0);
  g.gain.exponentialRampToValueAtTime(gain, c.currentTime + t0 + 0.015);
  g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + t0 + dur);
  o.connect(g);
  g.connect(c.destination);
  o.start(c.currentTime + t0);
  o.stop(c.currentTime + t0 + dur + 0.05);
}

// Goed antwoord: twee korte, oplopende toontjes.
export const playCorrect = (): void => { if (isMuted()) return; tone(660, 0, 0.12); tone(880, 0.09, 0.16); };

// Fout antwoord: één zachte, lage plof (vriendelijk, niet straffend).
export const playWrong = (): void => { if (isMuted()) return; tone(196, 0, 0.18, 'triangle', 0.045); };

// Afgerond/geslaagd: klein oplopend loopje.
export const playDone = (): void => {
  if (isMuted()) return;
  [523.25, 659.25, 783.99, 1046.5].forEach((f, i) => tone(f, i * 0.09, 0.22));
};
